import React from 'react';

const GitHubLink = ({ url }) => {
  return (
    <div className="github-link">
      <a href={url} target="_blank" rel="noopener noreferrer">
        <button>Download Patch!</button>
      </a>
    </div>
  );
};

export default GitHubLink;